import { Injectable } from '@angular/core';
import { Platform } from '@angular/cdk/platform';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  constructor(private platform: Platform) {}

  get isBrowser(): boolean {
    return this.platform.isBrowser;
  }

  get isAndroid(): boolean {
    return this.platform.ANDROID;
  }

  get isIOS(): boolean {
    return this.platform.IOS;
  }

  get isIOSOrIPadOS(): boolean {
    return this.platform.IOS || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  get isCordova(): boolean {
    return typeof (window as any).cordova !== 'undefined';
  }

  get isCapacitor(): boolean {
    return typeof (window as any).Capacitor !== 'undefined';
  }

  get isNative(): boolean {
    return this.isCordova || this.isCapacitor;
  }

  get isMobile(): boolean {
    return this.isAndroid || this.isIOS;
  }

  get isDesktop(): boolean {
    return !this.isMobile;
  }

  get isPWA(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches;
  }
}
